import React, { useEffect, useRef, useGlobal } from "reactn";
import PropTypes from "prop-types";

// styled components
import { HeaderStyled, NavigationStyled } from "./Header.styled";

// hooks
import Apphook from "../../../hooks/appHook";

// helpers
import { truncateString } from "../../../helpers/Helpers";

const Header = ({ businessName, firstName, email, isMobile, history }) => {
    const [topNav] = useGlobal("topNav");
    const { copyTopNavigation, setNavProfileLinks } = Apphook();
    const navigationRef = useRef(null);


    // handle the titles if they return as null
    const handleWelcomeTitle = (name, emailAddress) => {
        if (name && name !== null) {
            return `Hi ${truncateString(firstName, 13)}`;
        }

        if (emailAddress && emailAddress !== null) {
            return `Hi ${truncateString(emailAddress, 13)}`;
        }

        return "Hi";
    };

    const handleWelcomeTitleAccessible = (name, emailAddress) => {
        if (name && name !== null) {
            return `Hi ${firstName}`;
        }

        if (emailAddress && emailAddress !== null) {
            return `Hi ${emailAddress}`;
        }

        return "Hi";
    };

    useEffect(() => {
        copyTopNavigation();
    }, []);

    useEffect(() => {
        const navigation = navigationRef.current;
        if (!navigation) return;
        const basketButton = navigation.querySelector(".submenu-dropdown.basket");
        const basketModal = navigation.querySelector(".m58");
        const userDropdownBtn = navigation.querySelector("[data-m59-trigger]");
        const userDropdownMenu = navigation.querySelector("[data-m59-dropdown]");

        if (!basketButton || !userDropdownBtn || !userDropdownMenu) return;
        const dropdownLinks = userDropdownMenu.querySelectorAll(".m59__list.user li a");
        const allClickableEl = navigation.querySelectorAll("a, button");
        const userName = JSON.parse(sessionStorage.getItem("userProfile")).profile.firstName;
        const userEmail = JSON.parse(sessionStorage.getItem("userProfile")).email;

        userDropdownBtn.querySelector("span").innerHTML = userName || truncateString(userEmail, 10);

        basketButton.addEventListener("click", e => {
            e.preventDefault();
            e.stopPropagation();
            basketModal.classList.toggle("m58--open");
            userDropdownMenu.classList.remove("expanded");
            basketButton.setAttribute("aria-expanded", `${basketModal.classList.contains("m58--open") ? "true" : "false"}`);
        });

        userDropdownBtn.addEventListener("click", e => {
            e.stopPropagation();
            userDropdownMenu.classList.toggle("expanded");
            basketModal.classList.remove("m58--open");
            userDropdownBtn.setAttribute("aria-expanded", `${userDropdownMenu.classList.contains("expanded") ? "true" : "false"}`);
        });

        document.addEventListener("click", () => {
            basketModal.classList.remove("m58--open");
            userDropdownMenu.classList.remove("expanded");
            basketButton.setAttribute("aria-expanded", "false");
            userDropdownBtn.setAttribute("aria-expanded", "false");
        });

        setNavProfileLinks(dropdownLinks, history);

        allClickableEl.forEach(el => {
            el.classList.remove("gtm-header");
            el.classList.add("gtm-headerMACH");
        });
    }, [topNav, isMobile]);

    return (
        <>
            <HeaderStyled>
                <div className="header__container">
                    <div className="header__title">
                        <h1>
                          <span aria-hidden="true">{handleWelcomeTitle(firstName, email)}</span>
                          <span className="visually-hidden">{handleWelcomeTitleAccessible(firstName, email)}</span>
                          
                        </h1>
                        {businessName && <p className="business__title">{businessName}</p>}
                    </div>
                    <div>
                        {!isMobile && <NavigationStyled ref={navigationRef} dangerouslySetInnerHTML={topNav}></NavigationStyled>}
                    </div>
                </div>
            </HeaderStyled>
        </>
    );
};

export default Header;

Header.propTypes = {
    businessName: PropTypes.string,
    firstName: PropTypes.string,
    email: PropTypes.string,
    isMobile: PropTypes.bool,
    history: PropTypes.object
};
